module.exports = __webpack_public_path__ + "img/team-dark-05.e818f35f.jpg";